module.exports = __webpack_public_path__ + "img/hint2.17aeafe4.png";